module.exports = __webpack_public_path__ + "img/files.972dc4ae.svg";